import { nanoid } from 'nanoid';
import { ChangeEvent } from 'react';

import './Checkbox.scss';

interface Props {
  label?: string;
  value?: boolean;
  onChangeValue?: (isChecked: boolean) => void;
  rect?: boolean;
}

const Checkbox = ({
  label, value, onChangeValue, rect = false, ...rest
}: Props): JSX.Element => {
  const checkboxId = nanoid();
  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeValue && onChangeValue(
      !!(e && e.nativeEvent && e.nativeEvent.target && (e.nativeEvent.target as { checked?: boolean }).checked),
    );
  };

  return (
    <div>
      <div className="form__radio">
        <label htmlFor={checkboxId} className="form__radio-label">
          <input
            id={checkboxId}
            className="form__radio-input"
            type="checkbox"
            onChange={handleChangeValue}
            checked={value}
            {...rest}
          />
          <div className={`form__radio-ico ${rect ? 'form__radio-ico-rect' : ''}`} />
          {label && <span>{label}</span>}
        </label>
      </div>
    </div>
  );
};

export default Checkbox;
